import { cn } from '@/lib/utils';

interface CyberIconProps {
    size?: number;
    className?: string;
}

const BASE_TRANSITION =
    'transition-[transform,stroke,opacity] duration-200 ease-out motion-reduce:transition-none';

export function CyberDepositIcon({ size = 24, className }: CyberIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="miter"
            className={cn('shrink-0', className)}
            aria-hidden="true"
        >
            <g
                className={cn(
                    BASE_TRANSITION,
                    'group-hover:translate-y-[2px] group-hover:[stroke:var(--success)]',
                    'motion-reduce:group-hover:translate-y-0',
                )}
            >
                <line x1="12" y1="3" x2="12" y2="12" />
                <polyline points="8,9 12,13 16,9" />
            </g>
            <g
                className={cn(
                    BASE_TRANSITION,
                    'opacity-30',
                    'group-hover:opacity-90 group-hover:[stroke:var(--success)]',
                )}
            >
                <line x1="9.5" y1="5" x2="14.5" y2="5" strokeWidth="1" />
                <line x1="10" y1="7.5" x2="14" y2="7.5" strokeWidth="1" />
            </g>
            <g className={BASE_TRANSITION}>
                <path d="M5 14 V18 L7 20 H17 L19 18 V14" />
                <line x1="5" y1="14" x2="8.5" y2="14" />
                <line x1="15.5" y1="14" x2="19" y2="14" />
            </g>
        </svg>
    );
}

export function CyberWithdrawIcon({ size = 24, className }: CyberIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="miter"
            className={cn('shrink-0', className)}
            aria-hidden="true"
        >
            <g
                className={cn(
                    BASE_TRANSITION,
                    'group-hover:-translate-y-[2px] group-hover:[stroke:var(--destructive)]',
                    'motion-reduce:group-hover:translate-y-0',
                )}
            >
                <line x1="12" y1="16" x2="12" y2="6" />
                <polyline points="8,9.5 12,5.5 16,9.5" />
            </g>
            <g
                className={cn(
                    BASE_TRANSITION,
                    'opacity-30',
                    'group-hover:opacity-90 group-hover:[stroke:var(--destructive)]',
                )}
            >
                <line x1="9.5" y1="12" x2="14.5" y2="12" strokeWidth="1" />
                <line x1="10" y1="10" x2="14" y2="10" strokeWidth="1" />
            </g>
            <g className={BASE_TRANSITION}>
                <path d="M5 14 V18 L7 20 H17 L19 18 V14" />
                <line x1="5" y1="14" x2="8.5" y2="14" />
                <line x1="15.5" y1="14" x2="19" y2="14" />
            </g>
        </svg>
    );
}
